namespace GeniuzPOS.InventoryReport {
    export class IcReport04Columns {
        static columnsKey = 'InventoryReport.IcReport04';
    }
}
